import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.min.css';

const KeywordGroupingTool = () => {
  const [keywords, setKeywords] = useState([]);
  const [groups, setGroups] = useState({});
  const [selectedGroup, setSelectedGroup] = useState("");

  // Handle manual keyword input
  const handleInputChange = (event) => {
    const inputText = event.target.value;
    const keywordArray = inputText.split("\n").map((kw) => kw.trim()).filter(Boolean);
    setKeywords(keywordArray);
  };

  // Handle file upload
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
      const fileKeywords = rows.flat().map((kw) => kw.trim()).filter(Boolean);
      setKeywords(fileKeywords);
    };
    reader.readAsArrayBuffer(file);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // Group keywords (case-insensitive) and handle "Others" category
  const groupKeywords = () => {
    const tempGroups = keywords.reduce((acc, keyword) => {
      const normalizedKey = keyword.split(" ")[0].toLowerCase(); // Use lowercase for grouping
      if (!acc[normalizedKey]) acc[normalizedKey] = [];
      acc[normalizedKey].push(keyword); // Preserve original keyword case
      return acc;
    }, {});

    // Move groups with less than 3 keywords to "Others"
    const others = [];
    const finalGroups = Object.entries(tempGroups).reduce((acc, [key, value]) => {
      if (value.length < 3) {
        others.push(...value);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {});

    if (others.length > 0) {
      finalGroups["others"] = others;
    }

    setGroups(finalGroups);
    setSelectedGroup(Object.keys(finalGroups)[0]); // Default selection
  };

  // Handle group selection
  const handleGroupSelect = (group) => {
    setSelectedGroup(group);
  };

  return (
    <div className="container py-5">
    
     

      {/* Textarea for manual input */}
      <textarea
        rows="5"
        placeholder="Enter keywords (one per line)..."
        onChange={handleInputChange}
        className="form-control mb-4"
      ></textarea>

      {/* File upload */}
      <div
        {...getRootProps()}
        className="border border-primary p-3 text-center mb-4"
        style={{ borderStyle: "dashed", cursor: "pointer" }}
      >
        <input {...getInputProps()} />
        <p className="mb-0">Drop your file here or <strong>browse</strong> to upload xlsx/csv file</p>
      </div>

      {/* Button to create groups */}
      <button className="btn btn-primary btn-block mb-4" onClick={groupKeywords}>
        Create Groups
      </button>

      {/* Display grouped keywords */}
      {Object.keys(groups).length > 0 && (
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-3">
            <div className="border rounded p-3">
              <h5 className="mb-3">All Keywords</h5>
              <ul className="list-group">
                {Object.entries(groups).map(([group, groupKeywords], index) => (
                  <li
                    key={index}
                    className={`list-group-item d-flex justify-content-between align-items-center ${
                      selectedGroup === group ? "active" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleGroupSelect(group)}
                  >
                    <span className="text-capitalize">{group}</span>
                    <span className="badge badge-primary badge-pill text-black">
                      {groupKeywords.length}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-9">
            <div className="border rounded p-3">
              {selectedGroup && (
                <div>
                  <h5 className="mb-3">Group "{selectedGroup}": {groups[selectedGroup].length} keywords</h5>
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>Keyword</th>
                        <th>Word Count</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groups[selectedGroup].map((keyword, i) => (
                        <tr key={i}>
                          <td>{keyword}</td>
                          <td>{keyword.split(" ").length}</td>
                          <td>
                            <button className="btn btn-primary btn-sm">
                             <a target="_blank" className="text-decoration-none text-white" href="https://app.aibuster.com/login">Generate Article</a>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KeywordGroupingTool;
